import { render, staticRenderFns } from "./plugin-group-folder.vue?vue&type=template&id=06c1c041&scoped=true&"
import script from "./plugin-group-folder.vue?vue&type=script&lang=js&"
export * from "./plugin-group-folder.vue?vue&type=script&lang=js&"
import style0 from "./plugin-group-folder.vue?vue&type=style&index=0&id=06c1c041&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1c041",
  null
  
)

export default component.exports